import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_UGC_LINK_REDIRECT_ALLOWLIST = defineFcm('ugc_link_redirect_allowlist')
	.asJson(
		z.object({
			domains: z.array(z.string()),
			exactHosts: z.array(z.string()),
			tlds: z.array(z.string()),
		}),
	)
	.withDefault({ domains: [], exactHosts: [], tlds: [] })
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'UGC link processing',
		description:
			'Trusted domains, hosts, and TLDs that skip the /redirect?to=... offsite interstitial for links found in user-generated content (petition/movement descriptions, updates, DM responses, comments), even though they are off Change.org. Does not affect vanity-URL redirects, which build their own /redirect?to=... independently (see vanityUrlRedirect.ts) and are not gated by this config. "domains" entries (e.g. "bbc.co.uk") match that domain and all its subdomains. "exactHosts" entries (e.g. "www.bbc.co.uk") match only that exact host — not its subdomains, not its parent domain; use this for pinning one specific host without trusting the whole domain family. "tlds" entries (e.g. "gov", "gov.uk") match any hostname ending in that suffix.',
		template: { domains: ['bbc.co.uk'], exactHosts: ['www.nytimes.com'], tlds: ['gov', 'gov.uk'] },
	});
